import(/* webpackMode: "eager" */ "/opt/build/repo/app/about/page.tsx");
